export default {
  props: ["modelOpacityValue"],
  data() {
    return {
      modelTransparency_show: true,
      modelOpacity: this.modelOpacityValue * 100,
      isFold: false,
    };
  },
  watch: {
    // modelOpacityValue(){
    // 	this.modelOpacity=this.modelOpacityValue*100;
    // 	alert("触发！");
    // }
  },
  methods: {
    initData(Opacity) {
      this.modelOpacity = Opacity * 100;
      //alert(100);
    },
    adjustModelOpacity() {
      this.$emit(
        "changeModelTransparency",
        (this.modelOpacity / 100).toFixed(2)
      );
      //console.log(this.modelOpacity);
    },
    modelTransparencyBox_close() {
      this.$emit("modelTransparencyBox_close");
    },
  },
  mounted() {},
  watch: {},
  filters: {
    numFilter(value) {
      let realVal = parseFloat(value).toFixed(2);
      return realVal;
    },
  },
};
